import { useRef } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import Plus from 'shared/icons/Plus';

import { FormError } from '@components/form-error';

import { useStore } from 'models/stores';

export default observer(({ error, onChange, disabled }) => {
  const {
    uiStore: { t },
  } = useStore();
  const inputRef = useRef(null);

  const uploadClick = () => inputRef.current.click();
  const changeFile = (e) => {
    const file = e.target.files.length > 0 ? e.target.files[0] : null;
    onChange(file);
  };

  return (
    <Container>
      <UploadContainer onClick={disabled ? null : uploadClick} error={error} disabled={disabled}>
        <PlusBox />
        <AddButtonText>{t('helpers_add')}</AddButtonText>
      </UploadContainer>
      <FormError text={error} />
      <input style={{ display: 'none' }} type="file" ref={inputRef} onChange={changeFile} />
    </Container>
  );
});

const PlusBox = styled(Plus)`
  fill: ${(p) => p.theme.textColor};
`;

const Container = styled.div`
  margin: 8px 0;
  display: flex;
  flex-direction: row-reverse;
`;

const AddButtonText = styled.div`
  margin-left: 16px;
  opacity: 0.5;
`;

const UploadContainer = styled.div`
  display: flex;
  padding: 14px;
  justify-content: flex-start;
  background-color: inherit;
  color: ${(p) => p.theme.textColor};
  font-size: 11px;
  font-weight: bold;
  line-height: 13px;
  height: 37px;
  align-items: center;
  border: 1px solid ${(p) => (p.error ? p.theme.errorColor : p.theme.textColor)};
  border-radius: 4px;
  ${(p) => p.disabled && 'opacity: 0.65;'};

  :hover {
    cursor: ${(p) => (p.disabled ? 'auto' : 'pointer')};
  }
`;
